import React from 'react';
export function Hero() {
  return <section className="relative pt-4 pb-8 md:pt-8 md:pb-12 overflow-hidden" aria-label="Presentación del Kit Adulto de Rescate" style={{
    contain: 'layout'
  }} data-id="element-110">
      <div className="container mx-auto px-4 relative z-10" data-id="element-111">
        <div className="flex flex-col items-center" data-id="element-112">
          <div className="flex-1 text-center max-w-3xl" data-id="element-113">
            <h1 className="text-5xl md:text-7xl font-bold leading-tight mb-6" data-id="element-114">
              <span className="block bg-clip-text bg-gradient-to-r from-white to-gray-400 text-[24px] text-[#D4A943]" data-id="element-115">
                ¿Tu hijo se cierra, explota o se apaga... y ya no sabés qué
                hacer?
              </span>
            </h1>

            {/* Hero image - reduced size for faster LCP */}
            <div className="mb-8" data-id="element-116">
              <img src="https://cdn.magicpatterns.com/uploads/i776b2UpPBaFBpfrGjUA49/Diseno_sin_titulo_(2)_(1).png" alt="Adulto de Rescate — Kit Anti-Crisis para padres de adolescentes" className="mx-auto block w-[280px] md:w-[380px]" width={380} height={380} fetchPriority="high" decoding="async" data-id="element-117" />
            </div>

            <p className="text-xl md:text-2xl text-gray-300 font-medium mb-4" data-id="element-118">
              Las herramientas exactas que ningún libro de crianza te dio. Para
              esta noche. Para mañana a la mañana. Para la próxima explosión
            </p>

            <button onClick={() => {
            const target = document.getElementById('elegir-plan');
            if (target) {
              target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }
          }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-5 text-lg font-bold text-background bg-gold rounded-xl hover:bg-gold/90 transition-colors uppercase tracking-wider cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" data-id="element-119">
              🛡️ → Quiero mi Kit Adulto de Rescate Ahora
            </button>

            <div className="flex flex-wrap justify-center gap-4 mt-8 mb-6" role="list" aria-label="Características principales" data-id="element-120">
              <div className="flex gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5 flex-row items-center" role="listitem" data-id="element-121">
                <span className="text-2xl" aria-hidden="true" data-id="element-122">
                  🩹
                </span>
                <span className="font-medium text-sm" data-id="element-123">100% Práctico</span>
              </div>
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-124">
                <span className="text-2xl" aria-hidden="true" data-id="element-125">
                  ⚡
                </span>
                <span className="font-medium text-sm" data-id="element-126">Acceso Inmediato</span>
              </div>
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5 flex-col justify-center" role="listitem" data-id="element-127">
                <span className="text-2xl" aria-hidden="true" data-id="element-128">
                  🛡️
                </span>
                <span className="font-medium text-sm" data-id="element-129">Todas las crisis</span>
              </div>
            </div>

            <div className="flex flex-wrap justify-center items-center gap-6 mt-6 text-sm text-gray-400" data-id="element-130">
              <div className="flex items-center gap-2" data-id="element-131">
                <span className="text-gold" aria-hidden="true" data-id="element-132">
                  ✓
                </span>
                <span data-id="element-133">Garantía 7 días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-134">
                <span className="text-gold" aria-hidden="true" data-id="element-135">
                  🔒
                </span>
                <span data-id="element-136">Pago seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-137">
                <span className="text-gold" aria-hidden="true" data-id="element-138">
                  💳
                </span>
                <span data-id="element-139">Mercado Pago</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}